import { Link } from "react-router-dom";
import carousel1 from './img/carousel-1.jpg';
import carousel2 from './img/carousel-2.jpg';
import about from './img/about.jpg';
import profile from './img/profile.jpg';
import feature from './img/feature.jpg';
import icon07 from './img/icon/icon-07-primary.png';
import icon06 from './img/icon/icon-06-primary.png';
import icon03 from './img/icon/icon-03-primary.png';
import icon04 from './img/icon/icon-04-primary.png';
import icon10light from './img/icon/icon-10-light.png';
import icon01light from './img/icon/icon-01-light.png';
import icon06light from './img/icon/icon-06-light.png';
import icon05light from './img/icon/icon-05-light.png';
import icon08light from './img/icon/icon-08-light.png';
import icon07light from './img/icon/icon-07-light.png';
import team1 from './img/team-1.jpg';
import team2 from './img/team-2.jpg';
import team3 from './img/team-3.jpg';
import team4 from './img/team-4.jpg';

function Services() {
  window.scrollTo(0,0);
    return (
        <>
        <div
      className="container-fluid page-header py-5 mb-5 wow fadeIn"
      data-wow-delay="0.1s"
    >
      <div className="container py-5">
        <h1 className="display-4 animated slideInDown mb-4">Services</h1>
        {/* <nav aria-label="breadcrumb animated slideInDown">
          <ol class="breadcrumb mb-0">
            <li class="breadcrumb-item"><a href="#">Home</a></li>
            <li class="breadcrumb-item"><a href="#">Pages</a></li>
            <li class="breadcrumb-item active" aria-current="page">About</li>
          </ol>
        </nav> */}
      </div>
    </div>

    {/* <!-- Service Start --> */}
    <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center mx-auto" style={{maxWidth: "500px"}}>
          <h1 className="display-6 mb-5">
            We provide professional Insurance Services
          </h1>
        </div>
        <div className="row g-4 justify-content-center">
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="service-item rounded h-100 p-5">
              <div className="d-flex align-items-center ms-n5 mb-4">
                <div
                  className="service-icon flex-shrink-0 bg-primary rounded-end me-4"
                >
                  <img
                    className="img-fluid"
                    src={icon10light}
                    alt=""
                  />
                </div>
                <h4 className="mb-0">Life Insurance</h4>
              </div>
              <p className="mb-4">
              Our life insurance plans provide financial protection to our clients' 
              loved ones in the event of their passing.
              </p>
              {/* <a className="btn btn-light px-3" href="">Read More</a> */}
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="service-item rounded h-100 p-5">
              <div className="d-flex align-items-center ms-n5 mb-4">
                <div
                  className="service-icon flex-shrink-0 bg-primary rounded-end me-4"
                >
                  <img
                    className="img-fluid"
                    src={icon01light}
                    alt=""
                  />
                </div>
                <h4 className="mb-0">Health Insurance</h4>
              </div>
              <p className="mb-4">
              We provide individual and family 
              health insurance plans that offer comprehensive coverage for medical expenses.
              </p>
              {/* <a className="btn btn-light px-3" href="">Read More</a> */}
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item rounded h-100 p-5">
              <div className="d-flex align-items-center ms-n5 mb-4">
                <div
                  className="service-icon flex-shrink-0 bg-primary rounded-end me-4"
                >
                  <img
                    className="img-fluid"
                    src={icon05light}
                    alt=""
                  />
                </div>
                <h4 className="mb-0">Home Insurance</h4>
              </div>
              <p className="mb-4">
              Ensure your home is safe from unforeseen risks with our simple home insurance policy.
              </p>
              {/* <a className="btn btn-light px-3" href="">Read More</a> */}
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="service-item rounded h-100 p-5">
              <div className="d-flex align-items-center ms-n5 mb-4">
                <div
                  className="service-icon flex-shrink-0 bg-primary rounded-end me-4"
                >
                  <img
                    className="img-fluid"
                    src={icon08light}
                    alt=""
                  /> 
                </div>
                <h4 className="mb-0">General Insurance</h4>
              </div>
              <p className="mb-4">
              We offer a range of general insurance products, 
              including motor insurance, home insurance, and travel insurance.
              </p>
              {/* <a className="btn btn-light px-3" href="">Read More</a> */}
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="service-item rounded h-100 p-5">
              <div className="d-flex align-items-center ms-n5 mb-4">
                <div
                  className="service-icon flex-shrink-0 bg-primary rounded-end me-4"
                >
                  <img
                    className="img-fluid"
                    src={icon07light}
                    alt=""
                  />
                </div>
                <h4 className="mb-0">Corporate Insurance</h4>
              </div>
              <p className="mb-4">
              Our corporate insurance plans provide comprehensive coverage for businesses, including liability insurance, property insurance, and employee benefits.
              </p>
              {/* <a className="btn btn-light px-3" href="">Read More</a> */}
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item rounded h-100 p-5">
              <div className="d-flex align-items-center ms-n5 mb-4">
                <div
                  className="service-icon flex-shrink-0 bg-primary rounded-end me-4"
                >
                  <img
                    className="img-fluid"
                    src={icon06light}
                    alt=""
                  />
                </div>
                <h4 className="mb-0">Risk Management</h4>
              </div>
              <p className="mb-4">
              We help our clients identify and mitigate risks, providing tailored risk management solutions that meet their unique needs.
              </p>
              {/* <a className="btn btn-light px-3" href="">Read More</a> */}
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* <!-- Service End --> */}


        </>
    )
}
export default Services;